var React = require('react');

function CloseJumbo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.9857 2L12 9.98571L4.01429 2L2 4.01429L9.98571 12L2 19.9857L4.01429 22L12 14.0143L19.9857 22L22 19.9857L14.0143 12L22 4.01429L19.9857 2Z","fill":"#2E3A59"}));
}

CloseJumbo.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CloseJumbo;

CloseJumbo.default = CloseJumbo;
